/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { Grid, InputLabel, FileDrop, Button, Loader, Icon } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import { util } from '@keystone/common';
import { withRouter } from 'react-router-dom';
import AppModal from '../../partials/AppModal';
import Routes from '../../common/routes';
import {
  withApplicationContext,
  withCustomerSiteContext,
  withOperatorContext,
} from '../../common/HOCs';

const downloadStyle = {
  color: '#303030',
};

const deleteStyle = {
  backgroundColor: '#EE3124',
  borderColor: '#EE3124',
};

const buttonPadding = {
  paddingTop: '10px',
  paddingRight: '1.5rem',
  paddingBottom: '0.5rem',
  paddingLeft: '1.5rem',
};

class ManageOperatorTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  onAccepted = async (file) => {
    const { appContext } = this.props;
    const data = new FormData();
    data.append('data', file[0]);
    data.append('operatorIdentifier', this.props.operatorContext.selectedOperator.operatorId);
    this.setState({ loading: true });
    await this.props.operatorContext.uploadTemplates(data);
    await appContext.reload();
    this.setState({ loading: false });
  };

  deleteAFile = (cellData) => {
    this.props.operatorContext.setTemplateSelectedRow(cellData);
    this.props.operatorContext.toggleConfirmTemplateDeleteOperatorModal();
  };

  deleteConfirmTemplate = async () => {
    const { appContext } = this.props;
    this.props.operatorContext.toggleConfirmTemplateDeleteOperatorModal();
    this.setState({ loading: true });
    await this.props.operatorContext.deleteTemplate(
      this.props.operatorContext.selectedOperator.operatorId
    );
    await appContext.reload();
    this.setState({ loading: false });
  };

  deleteAllTemplates = () => {
    this.props.operatorContext.toggleConfirmTemplateDeleteAllOperatorModal();
  };

  deleteConfirmAllTemplates = async () => {
    const { appContext } = this.props;
    this.props.operatorContext.toggleConfirmTemplateDeleteAllOperatorModal();
    this.setState({ loading: true });
    await this.props.operatorContext.deleteAllTemplate(
      this.props.operatorContext.selectedOperator.operatorId
    );
    await appContext.reload();
    this.setState({ loading: false });
  };

  deleteActionRenderer = (cellData) => (
    <Button
      type="primary"
      size="small"
      content="Delete"
      style={deleteStyle}
      onClick={() => this.deleteAFile(cellData.rowData)}
    />
  );

  componentDidMount() {
    const { appContext, history } = this.props;
    appContext.registerReloadFunction(this.reloadTableComponent);
    appContext.setRedirectFunction(() => {
      history.push(Routes.Operators);
    });
    this.initializeTable();
    appContext.setNotification(null);
  }

  reloadTableComponent = async (signal) => {
    await this.props.operatorContext.fetchTemplates(
      this.props.operatorContext.selectedOperator.operatorId,
      signal
    );
  };

  initializeTable = async () => {
    this.setState({ loading: true });
    await this.props.operatorContext.fetchTemplates(
      this.props.operatorContext.selectedOperator.operatorId
    );
    this.setState({ loading: false });
  };

  componentWillUnmount() {
    const { appContext, operatorContext } = this.props;
    appContext.unregisterReloadFunction();
    operatorContext.clearSelectedOperatorTemplates();
    this.clearSelectionAfterCancelEdit();
  }

  clearSelectionAfterCancelEdit = () => {
    this.props.operatorContext.clearSelectedOperators();
  };

  render() {
    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <h3>Manage Operator Templates</h3>
              <Loader loading={this.state.loading} overlayOpacity={0.2} overlayColor="#B2AFAF">
                <div className="placeholder" />
              </Loader>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={1}>
              <InputLabel label="User Name" />
            </Grid.Column>
            <Grid.Column width={11}>
              {this.props.operatorContext.selectedOperator.operatorId}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={1}>
              <InputLabel label="Templates" />
            </Grid.Column>
            <Grid.Column width={11}>
              <FileDrop
                acceptedTypes={['.zip']}
                placeholder="Drop or Upload Template Files"
                onAccepted={(file) => this.onAccepted(file)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={9} />
            <Grid.Column width={3}>
              <AppModal
                isOpen={this.props.operatorContext.isConfirmTemplateDeleteModalOpen}
                content="Would you like to delete the selected template?"
                handleSubmit={() => this.deleteConfirmTemplate()}
                handleToggle={() =>
                  this.props.operatorContext.toggleConfirmTemplateDeleteOperatorModal()
                }
              />

              <AppModal
                isOpen={this.props.operatorContext.isConfirmTemplateDeleteAllModalOpen}
                content="Would you like to delete the selected template?"
                handleSubmit={() => this.deleteConfirmAllTemplates()}
                handleToggle={() =>
                  this.props.operatorContext.toggleConfirmTemplateDeleteAllOperatorModal()
                }
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <br />
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <DataTable
                data={
                  this.props.operatorContext.templates === null
                    ? []
                    : this.props.operatorContext.templates === undefined
                    ? []
                    : this.props.operatorContext.templates
                }
                resizableColumns
                columnResizeMode="fit"
                reorderableColumns={false}
                metaKeySelection={false}
                scrollable
                scrollHeight="150%"
                search
              >
                {this.props.operatorContext.templates != null &&
                this.props.operatorContext.templates.length > 0 ? (
                  <DataTable.HeaderBar>
                    <DataTable.HeaderBar.Item
                      icon={
                        <Icon name="cloud-download" size="small" root="common">
                          <a
                            onClick={() => null}
                            style={downloadStyle}
                            href={
                              `${util.getAPIGatewayURL()}/voice/template/gui` +
                              `?id_token=${this.props.operatorContext.getIdToken()}` +
                              `&path=${this.props.operatorContext.selectedOperator.operatorId}%5C*%5C*.bt2` +
                              `&selectedClientId=${this.props.custSiteContext.selectedCustomer}`
                            }
                          >
                            Download All
                          </a>
                        </Icon>
                      }
                    />
                    <DataTable.HeaderBar.Item
                      content="Delete All"
                      icon={<Icon name="delete" size="small" root="common" />}
                      onClick={() => this.deleteAllTemplates()}
                    />
                    <DataTable.HeaderBar.Item content="" />
                  </DataTable.HeaderBar>
                ) : null}

                <DataTable.Column field="word" header="Word" sortable initialWidth={20} />
                <DataTable.Column
                  field="templateLanguage"
                  header="Locale"
                  sortable
                  initialWidth={20}
                />
                <DataTable.Column field="extension" header="Type" sortable initialWidth={20} />
                <DataTable.Column
                  field="displayFileSize"
                  header="Size"
                  sortable
                  initialWidth={20}
                />
                <DataTable.Column
                  field="fileCreatedDate"
                  header="Date"
                  sortable
                  initialWidth={20}
                />
                <DataTable.Column
                  field="actions"
                  header="Actions"
                  renderer={this.deleteActionRenderer}
                  initialWidth={20}
                />
              </DataTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <br />
        <Grid>
          <Grid.Row>
            <Grid.Column width={10} />
            <Grid.Column width={2}>
              <Button
                type="secondary"
                content="Cancel"
                onClick={async () => {
                  this.props.history.push(Routes.Operators);
                  this.clearSelectionAfterCancelEdit();
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(
  withApplicationContext(withCustomerSiteContext(withOperatorContext(ManageOperatorTemplates)))
);
